module.exports = __webpack_public_path__ + "media/B1.87beced1.mp3";